import { tierFor, type Tier } from './tiers';

/**
 * One-line reactions shown on the reveal, chosen by tier. Deterministic for a given guess so a
 * reload shows the same line. Sports-flavoured on purpose; keep them short (one line on a phone).
 */
export const QUIPS: Record<Tier, readonly string[]> = {
  bullseye: [
    'Top bins. Where and when.',
    'Hole in one.',
    'Nothing but net.',
    'Photo finish, and you won it.',
    'Chalk that up as a world record.',
  ],
  green: [
    'Inside the penalty box.',
    'Comfortably on the podium.',
    'A tap-in from there.',
    'Winning line, minor wobble.',
    'The replay says: no complaints.',
  ],
  yellow: [
    'Ballpark. Literally.',
    'You hit the post.',
    'Good line, wrong length.',
    'Right neighbourhood, wrong stadium.',
    'Close enough for a VAR check.',
  ],
  orange: [
    'Wide of the mark.',
    'Off by a road trip.',
    'Wrong end of the pitch.',
    'That was the warm-up lap.',
    'The scouting report was hazy.',
  ],
  red: [
    'Wrong continent, right sport.',
    'Your compass took a transfer.',
    'That one sailed over the bar.',
    'Somebody check the map is the right way up.',
    'An own goal, but a brave one.',
  ],
};

export interface QuipInput {
  basePts: number;
  yearDiff: number;
  distanceKm: number;
  position: number;
}

/** Pick a quip for a guess; the same guess always yields the same line. */
export function quipFor({ basePts, yearDiff, distanceKm, position }: QuipInput): string {
  const tier = tierFor(basePts);
  const list = QUIPS[tier];
  const seed = position * 31 + Math.round(distanceKm) + Math.abs(yearDiff);
  const line = list[seed % list.length] ?? list[0] ?? '';
  if (tier !== 'bullseye' && yearDiff === 0 && distanceKm > 100)
    return `${line} Nailed the year, though.`;
  return line;
}
